import { styled } from "@vitality-ds/system";
import { components } from "react-select";
import baseOptionStyles from "./styles/baseOption.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseOption = styled(components.Option, baseOptionStyles);